import Cookies from 'js-cookie';

export function logOut(){
    localStorage.removeItem('loginMemberUserId');
    localStorage.removeItem('loginMemberUserName');
    localStorage.removeItem('loginMemberUserImage');
    localStorage.removeItem('loginEventMemberEmail');
    localStorage.removeItem('loginEventMemberUserId');
    localStorage.removeItem('isMember');
    localStorage.removeItem('isEventMember');
    Cookies.remove('memberUserId');
}